var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_8578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83408 24C2.06876 24 1.40508 23.7732 0.843049 23.3197C0.281017 22.8661 0 22.3305 0 21.7129V2.31604C0 1.67913 0.281017 1.1339 0.843049 0.680338C1.40508 0.226779 2.06876 0 2.83408 0H21.13C21.9193 0 22.5949 0.226779 23.157 0.680338C23.719 1.1339 24 1.67913 24 2.31604V21.7129C24 22.3305 23.719 22.8661 23.157 23.3197C22.5949 23.7732 21.9193 24 21.13 24H2.83408ZM2.83408 21.7129H21.13V2.31604H19.1928V8.97467C19.1928 9.22557 19.0732 9.40893 18.8341 9.52473C18.5949 9.64053 18.3558 9.64053 18.1166 9.52473L15.713 8.39566L13.3453 9.52473C13.0822 9.64053 12.8311 9.64053 12.5919 9.52473C12.3528 9.40893 12.2332 9.22557 12.2332 8.97467V2.31604H2.83408V21.7129ZM12.2332 2.31604H19.1928H12.2332ZM2.83408 2.31604H21.13H2.83408Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_8578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.2bb940d9e95258c83ad26cc3cabda7c2.svg";
export { ForwardRef as ReactComponent };